module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('h4', {
    staticClass: "font-w300 push-10"
  }, [_vm._v(_vm._s(_vm.labelFieldTitle[_vm.actualLanguage]))])]), _vm._v(" "), (_vm.messageRequestIsSending) ? _c('spinner', {
    attrs: {
      "size": "small"
    }
  }) : _c('div', [(_vm.actualStatus === '01') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "contact-msg"
    }
  }, [_vm._v(_vm._s(_vm.labelTextBoxTitle[_vm.actualLanguage]))]), _vm._v(" "), _c('div', {
    staticClass: "form-material form-material-primary"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userMessage),
      expression: "userMessage"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "contact-msg",
      "name": "contact-msg",
      "rows": "7",
      "placeholder": _vm.labelInFieldMessage[_vm.actualLanguage]
    },
    domProps: {
      "value": (_vm.userMessage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userMessage = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-sm-offset-3"
  }, [_c('button', {
    staticClass: "btn btn-block btn-success",
    attrs: {
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.sendSupportRequest()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-send pull-left"
  }), _vm._v(_vm._s(_vm.labelButtonSendMessage[_vm.actualLanguage]))])])])]) : _vm._e()]), _vm._v(" "), (_vm.actualStatus === 'MessageTransmitOk') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "contact-msg"
    }
  }, [_vm._v(_vm._s(_vm.messageTransmitOk[_vm.actualLanguage]))])]) : _vm._e(), _vm._v(" "), (_vm.actualStatus === 'MessageTransmitFail') ? _c('div', {
    staticClass: "row"
  }, [_c('label', {
    attrs: {
      "for": "contact-msg"
    }
  }, [_vm._v(_vm._s(_vm.messageTransmitFail[_vm.actualLanguage]))])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2169dfd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/help/TransmitHelpRequestForm.vue
// module id = 1508
// module chunks = 4